import React from "react";
import PageCover from "../components/PageCover";
import { Box, Container, Typography, Grid } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import construction_cover from "../assets/construction_cover.jpg";

const projects = [
  {
    title: "River Sand Mining",
    category: "Mining Operations",
    location: "Dhaka Region",
    image: "https://images.pexels.com/photos/416405/pexels-photo-416405.jpeg",
  },
  {
    title: "Bulk Logistics Supply",
    category: "Transportation",
    location: "Chattogram",
    image: "https://images.pexels.com/photos/93398/pexels-photo-93398.jpeg",
  },
  {
    title: "Apartment Construction",
    category: "Residential",
    location: "Gulshan",
    image: "https://images.pexels.com/photos/323780/pexels-photo-323780.jpeg",
  },
  {
    title: "Highway Development",
    category: "Infrastructure",
    location: "National Project",
    image: "https://images.pexels.com/photos/2219024/pexels-photo-2219024.jpeg",
  },
  {
    title: "Commercial Complex",
    category: "Commercial",
    location: "Uttara",
    image: "https://images.pexels.com/photos/323705/pexels-photo-323705.jpeg",
  },
  {
    title: "Industrial Site Supply",
    category: "Material Supply",
    location: "Gazipur",
    image: "https://images.pexels.com/photos/1105766/pexels-photo-1105766.jpeg",
  },
];

const stats = [
  { number: "300+", label: "Projects Delivered" },
  { number: "100+", label: "Active Clients" },
  { number: "25+", label: "Ongoing Sites" },
  { number: "150+", label: "Skilled Professionals" },
];

const Projects = () => {
  return (
    <>
      <PageCover
        title="Our Projects"
        subtitle="Built on trust. Driven by excellence."
        breadcrumb="Projects"
        bgImage={construction_cover}
      />
      {/* ================= PROJECT GRID ================= */}
      <Box py={10}>
        <Container>
          {/* Cards Wrapper */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 4,
              justifyContent: "center",
            }}
          >
            {projects.map((project, index) => (
              <Box
                key={index}
                className="projectCard"
                sx={{
                  width: 360, // Fixed width
                  backgroundColor: "#fff",
                  overflow: "hidden",
                  boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
                  transition: "all 0.3s ease",
                  cursor: "pointer",

                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow: "0 15px 35px rgba(0,0,0,0.12)",
                  },

                  "&:hover .arrowBox": {
                    backgroundColor: "#e0a800",
                  },
                }}
              >
                {/* Image */}
                <Box
                  component="img"
                  src={project.image}
                  alt={project.title}
                  sx={{
                    width: "100%",
                    height: 240,
                    objectFit: "cover",
                    display: "block",
                    filter: "grayscale(100%)",
                    transition: "all 0.5s ease",

                    ".projectCard:hover &": {
                      filter: "grayscale(0%)",
                      transform: "scale(1.05)",
                    },
                  }}
                />

                {/* Bottom Bar */}
                <Box
                  sx={{
                    display: "flex",
                    backgroundColor: "#e9ecef",
                    alignItems: "stretch",
                  }}
                >
                  {/* Text */}
                  <Box sx={{ flex: 1, p: 3 }}>
                    <Typography variant="h6" fontWeight={600}>
                      {project.title}
                    </Typography>

                    <Typography variant="body2" sx={{ color: "#555", mt: 0.5 }}>
                      {project.category}
                    </Typography>
                  </Box>

                  {/* Arrow Box */}
                  <Box
                    className="arrowBox"
                    sx={{
                      width: 80,
                      backgroundColor: "#fcb900",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "background-color 0.3s ease",
                    }}
                  >
                    <ArrowForwardIcon sx={{ color: "#000" }} />
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
        </Container>
      </Box>

      {/* ================= STATS SECTION ================= */}
      {/* ================= PROJECT STATS SECTION ================= */}
      <Box
        sx={{
          backgroundColor: "#000323",
          color: "#fff",
          py: { xs: 8, md: 12 },
        }}
      >
        <Container>
          <Grid container spacing={2} alignItems="stretch">
            {stats.map((stat, index) => (
              <Grid
                key={index}
                item
                sx={{
                  flex: {
                    xs: "0 0 100%", // 2 per row on mobile
                    sm: "0 0 48%", // 2 per row on small
                    md: "0 0 24%", // 4 per row on medium+
                  },
                  display: "flex",
                  boxShadow:"rgba(0, 0, 0, 0.35) 0px 5px 15px"
                }}
                >
                <Box
                  sx={{
                    position: "relative",
                    p: 4,
                    width: "100%",
                    border: "1px solid rgba(255,255,255,0.08)",
                    borderRadius: 2,
                    overflow: "hidden",
                    height: "100%",
                    "&:hover": {
                      backgroundColor: "#0a0f47",
                      borderColor: "#b38d0aa1",
                      transform: "translateY(-4px)",
                      transition: "all 0.3s ease",
                    }
                  }}
                >
                  {/* Background Watermark Number */}
                  <Typography
                    sx={{
                      position: "absolute",
                      top: "25%",
                      left: "65%",
                      transform: "translate(-50%, -50%)",
                      fontSize: { xs: "80px", md: "110px" },
                      fontWeight: 900,
                      color: "rgba(252,185,0,0.07)",
                      userSelect: "none",
                      pointerEvents: "none",
                    }}
                  >
                    {stat.number.replace("+", "")}
                  </Typography>

                  {/* Foreground Number */}
                  <Typography
                    variant="h2"
                    fontWeight={800}
                    color="#fcb900"
                    sx={{ position: "relative", zIndex: 2 }}

                  >
                    {stat.number}
                  </Typography>

                  {/* Label */}
                  <Typography
                    variant="body2"
                    sx={{
                      mt: 1.5,
                      letterSpacing: 1,
                      textTransform: "uppercase",
                      color: '#ffeebf',
                      position: "relative",
                      zIndex: 2,
                      fontWeight: 600,
                      fontSize: { xs: 14, md: 18 },
                    }}
                  >
                    {stat.label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Projects;
